<template>
  <div>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="false" />
    <b-row>
      <b-col cols="12" lg="12">
        <b-card no-header>
          <template slot="header">Add New User</template>
          <b-row class="justify-content-md-center">
            <b-col cols="12" md="4">
              <b-row>
                <!-- <b-col cols="12">
                  <b-form-group>
                    <label>Username *</label>
                    <b-form-input
                      v-model="user.username"
                      type="text"
                      id="username"
                      placeholder="Username"
                    ></b-form-input>
                  </b-form-group>
                </b-col> -->
                 <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('username')}">
                    <b-form-group label="Username *">
                      <b-form-input
                        v-model="username"
                        type="text"
                        id="username"
                        placeholder="Username"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('username')">
                        <span style="color:red;">{{validation.firstError('username')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <!-- <b-col cols="12">
                  <b-form-group>
                    <label>Name *</label>
                    <b-form-input v-model="user.name" type="text" id="name" placeholder="Name"></b-form-input>
                  </b-form-group>
                </b-col> -->
                 <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('name')}">
                    <b-form-group label="Name *">
                      <b-form-input
                        v-model="name"
                        type="text"
                        id="name"
                        placeholder="name"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('name')">
                        <span style="color:red;">{{validation.firstError('name')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Country</label>
                    <b-form-select
                      v-model="user.country"
                      :options="countries"
                      value-field="country"
                      text-field="country"
                    ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row> -->
              <!-- <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Age</label>
                    <b-form-input v-model="user.age" type="text" id="age" placeholder="Age"></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row> -->
              <!-- <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>User Type</label>
                    <b-form-select v-model="user.type" :options="userTypes" :disabled="true"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row> -->
              <b-row>
                <!-- <b-col cols="12">
                  <b-form-group>
                    <label>Email *</label>
                    <b-form-input
                      v-model="user.email"
                      type="text"
                      id="email"
                      placeholder="Email"
                    ></b-form-input>
                  </b-form-group>
                </b-col> -->
                 <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('email')}">
                    <b-form-group label="Email *">
                      <b-form-input v-model="email" type="text" id="email" placeholder="Email"></b-form-input>
                      <template slot="description" v-if="validation.firstError('email')">
                        <span style="color:red;">{{validation.firstError('email')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" md="4">
              <b-row>
                <!-- <b-col cols="12">
                  <b-form-group>
                    <label>Password *</label>
                    <b-form-input
                      v-model="user.password"
                      type="password"
                      id="password"
                      placeholder="••••••••"
                    ></b-form-input>
                  </b-form-group>
                </b-col> -->
                <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('password')}">
                    <b-form-group label="Password *">
                      <b-form-input
                        v-model="password"
                        type="text"
                        id="password"
                        placeholder="Password"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('password')">
                        <span style="color:red;">{{validation.firstError('password')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <!-- <b-col cols="12">
                  <b-form-group>
                    <label>Phone *</label>
                    
                        <b-form-input
                          v-model="user.phone"
                          type="text"
                          id="phone"
                          placeholder="Phone"
                        ></b-form-input>
                      
                  </b-form-group>
                </b-col> -->
                <b-col cols="12" md="12">
                  <div :class="{error: validation.hasError('phone')}">
                    <b-form-group label="Phone *">
                      <b-form-input
                        v-model="phone"
                        type="text"
                        id="phone"
                        placeholder="Phone number"
                      ></b-form-input>
                      <template slot="description" v-if="validation.firstError('phone')">
                        <span style="color:red;">{{validation.firstError('phone')}}</span>
                      </template>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Role</label>
                    <b-form-select v-model="role" :options="userTypes" disabled ></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
              <!-- <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>Gender</label>
                    <b-form-select v-model="user.gender" :options="genders"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row> -->
              
              <!-- <b-row>
                <b-col cols="12">
                  <b-form-group>
                    <label>User Role</label>
                    <b-form-select v-model="user.role" :options="userRoles" :disabled="true"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row> -->
            </b-col>
          </b-row>
          <b-row class="py-2 justify-content-md-center">
            <span style="color:red">{{msg}}</span>
          </b-row>
          <b-row class="justify-content-center">
            <div class="px-2">
              <b-button variant="outline-primary" size="sm" @click.prevent="inputCheck">Submit</b-button>
            </div>
          </b-row>
          <template slot="footer">
            <b-button @click="$router.go(-1)" size="sm">Back</b-button>
          </template>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      ServerError: false,
      appLoading: false,
      user: null,
      msg: null,
      propic: null,
      proPicImg: null,
      // genders: ["Male", "Female", "Others"],
      userTypes: ["Admin", "User"],
      // userRoles: ["Admin", "Sub Admin"],
      countries: [],
      
        username: null,
        password: null,
        name: null,
        email:null,
        phone: null,
        role:"Admin",
        
      
    };
  },
  validators: {
    email(value) {
      return this.Validator.value(value).required("Required Field").email();
    },
    phone(value) {
      return this.Validator.value(value)
        .required("Required Field")
        .regex("^[0-9]*$", "Please Input Valid Number.");
    },
    password(value) {
      return this.Validator.value(value).required("Required Field");
    },
    username(value) {
      return this.Validator.value(value).required("Required Field");
    },
    name(value) {
      return this.Validator.value(value).required("Required Field");
    },
  },

  methods: {
   
    // inputCheck() {
    //   this.msg = null;
    //   if (
    //     !this.user.name ||
    //     !this.user.username ||
    //     !this.user.phone ||
    //     !this.user.email ||
    //     !this.user.password
    //   )
    //     this.msg = "Please Provide required Fields marked with *";
    //   else this.addUser();
    // },

    inputCheck() {
      this.msg = null;
      this.$validate().then((success) => {
        if (success) {
          this.addUser();
        } else {
          this.msg = "Please validate input fields";
          return;
        }
      });
    },
    addUser() {
      var user = {};
      user["username"]=this.username;
      user["name"]=this.name;
      user["phone"]=this.phone;
      user["email"]=this.email;
      user["password"]=this.password;
      user["role"]=this.role;
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/createuser",
        headers: {
          "x-auth-token": localStorage.getItem("token")
        },
        data: user
      })
        .then(response => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Users");
          } else {
            this.msg = response.data.msg;
          }
        })
        .catch(err => {
          this.appLoading = false;
          this.ServerError = true;
        });
    }
  }
};
</script>
